import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { AddRequestedLoan } from 'services/loans'
import posthog from 'posthog-js'
interface IMutationFnPayload extends IAddLoanPayload {
    id: string
}
export default function useSetRequestedLoan({
    onDone,
}: {
    /**
     * Where to go once the request exists. Defaults to `navigate(-1)`, which
     * is right for the old single-form screen and WRONG for the wizard: every
     * wizard step is its own history entry, so -1 from the review step lands
     * on step 3 of a request that has already been filed.
     */
    onDone?: () => void
} = {}) {
    const navigate = useNavigate()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IMutationFnPayload) => {
            return AddRequestedLoan(payload)
        },
        onSuccess: (_, variables) => {
            toast.success('وام درخواستی با موفقیت ثبت شد')
            posthog.capture('loan_requested', {
                amount: (variables as any)?.amount,
                num_repayments: (variables as any)?.num_repayments,
                demand_priority: (variables as any)?.demand_priority,
                moneypool_id: (variables as any)?.id,
                // how many the member proposed, never who: the ids alone
                // would be enough to name them
                proposed_guarantor_count:
                    (variables as any)?.proposed_guarantors?.length ?? 0,
            })
            if (onDone) onDone()
            else navigate(-1)
        },
        onError: () => {
            posthog.capture('loan_request_failed')
            toast.error('خطایی رخ داده!')
        },
    })

    return { isLoading, mutate }
}
